module.exports = __webpack_public_path__ + "img/0.8b5577b9.svg";